/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import { ApiPrefixV1, ApiV1Base, ApiPrefix } from 'util/icwUtility';
import qs from 'qs';
import Request from './request';

export const apiGetSMSupplierDetail = async (id) => {
  return Request.call({
    url: `/micro/suppliers/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMLocations = async (params) => {
  return Request.call({
    url: '/areas/countries',
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetSMProvinces = async (countryName, params) => {
  return Request.call({
    url: `/areas/${countryName}/states`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetSMCities = async (countryName, stateName, params) => {
  return Request.call({
    url: `/areas/${countryName}/${stateName}/cities`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetSMTags = async (params) => {
  return Request.call({
    url: `/tags`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiGetCertificationTypes = async (params) => {
  return Request.call({
    url: `/micro/factory-audits/certificationType`,
    method: 'GET',
    params,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSMTag = async (data) => {
  return Request.call({
    url: `/tags`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};
export const apiCreateSMSupplier = async (data) => {
  return Request.call({
    url: `/micro/suppliers`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMSupplierList = async (params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMFactoryList = async (params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/factories?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMFactoryListBySupplierId = async (params, supplierId) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/${supplierId}/factories?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMSupplierQuantity = async () => {
  return Request.call({
    url: `/micro/suppliers/count`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMFactoryQuantity = async () => {
  return Request.call({
    url: `/micro/factories/count`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetProductQuantity = async () => {
  return Request.call({
    url: `/micro/products/count`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiGetSMFactoryDetail = async (id) => {
  return Request.call({
    url: `/micro/factories/${id}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiCreateSMFactory = async (data) => {
  return Request.call({
    url: `/micro/factories`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
export const apiUpdateSMSupplier = async (id, data, sub) => {
  return Request.call({
    url: `/micro/suppliers/${id}${sub ? `/${sub}` : ''}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSMProductList = async (params, supplierId) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/${supplierId}/products?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSMCurrentProduct = async (supplierId, params) => {
  const { keywords } = params;
  if (!keywords) {
    delete params.searchBy;
    delete params.keywords;
  }
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/suppliers/${supplierId}/currentProducts?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiAddCurrentProduct = async (supplierId, productIds) => {
  return Request.call({
    url: `/suppliers/${supplierId}/products`,
    method: 'POST',
    data: {
      productIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiGetSMCurrentFactory = async (supplierId, params, shouldSearchAll) => {
  const { keywords } = params;
  if (!keywords) {
    delete params.searchBy;
    delete params.keywords;
  }
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: shouldSearchAll
      ? `/micro/factories?${queryString}`
      : `/micro/suppliers/${supplierId}/factories?${queryString}`,
    // url: `/suppliers/${supplierId}/currentFactories?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiAddCurrentFactory = async (supplierId, factoryIds) => {
  return Request.call({
    url: `/suppliers/${supplierId}/factories`,
    method: 'POST',
    data: {
      factoryIds,
    },
    apiPrefix: `${ApiV1Base}${ApiPrefix}`,
  });
};

export const apiGetSupplierDocuments = async (supplierId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/${supplierId}/documentLists?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiAddSupplierDocuments = async (supplierId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/documentLists`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDeleteSupplierDocuments = async (supplierId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/documentLists`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSupplierCertifications = async (supplierId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/suppliers/${supplierId}/certifications?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetFactoryCertifications = async (supplierId, params) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/factories/${supplierId}/certifications?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiAddSupplierCertification = async (supplierId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/certifications`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDeleteSupplierCertification = async (supplierId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/certification`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiAddFactoryCertification = async (factoryId, data) => {
  return Request.call({
    url: `/micro/factories/${factoryId}/certifications`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDeleteFactoryCertification = async (factoryId, data) => {
  return Request.call({
    url: `/micro/factories/${factoryId}/certification`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiCreateSupplierInternalNotes = async (supplierId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/internalNotes`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSupplierInternalNotes = async (supplierId) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/internalNotes`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiUpdateSupplierInternalNotes = async (supplierId, internalNoteId, data) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/internalNotes/${internalNoteId}`,
    method: 'PUT',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDeleteSupplierInternalNotes = async (supplierId, internalNoteId) => {
  return Request.call({
    url: `/micro/suppliers/${supplierId}/internalNotes/${internalNoteId}`,
    method: 'DELETE',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

/** ***
 *
 * FACTORY
 * #region
 */

export const apiGetSMFactorySuppliers = async (params, factoryId) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/factories/${factoryId}/suppliers?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiGetSMFactoryDocuments = async (params, factoryId) => {
  const queryString = qs.stringify(params, {
    encodeValuesOnly: false,
    indices: false,
  });
  return Request.call({
    url: `/micro/factories/${factoryId}/documentLists?${queryString}`,
    method: 'GET',
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiAddFactoryDocuments = async (factoryId, data) => {
  return Request.call({
    url: `/micro/factories/${factoryId}/documentLists`,
    method: 'POST',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};

export const apiDeleteFactoryDocuments = async (factoryId, data) => {
  return Request.call({
    url: `/micro/factories/${factoryId}/documentLists`,
    method: 'DELETE',
    data,
    apiPrefix: `${ApiV1Base}${ApiPrefixV1}`,
  });
};
// #endregion
